import React from "react";
import { ArrowRight, FileText } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";

const inclusions = [
  { text: "Daily breakfast" },
  { text: "Free Wi-Fi" },
  { text: "Room service" },
  { text: "All taxes and service charges" },
];

export function ResortInclusions() {
  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold mb-4">Hotel Stay Includes:</h2>
        <ul className="space-y-2">
          {inclusions.map((item, index) => (
            <li key={index} className="flex items-center">
              <ArrowRight size={16} className="text-primary mr-3" />
              <span>{item.text}</span>
            </li>
          ))}
        </ul>
      </div>

      <p className="text-muted-foreground">
        Depending on your chosen room type and duration of stay, you can select from a variety of packages that include everything from luxury suites to more affordable options. We offer some of the best deals on hotel stays in Dubai, with a variety of amenities to ensure your comfort during your visit.
      </p>

      <Dialog>
        <DialogTrigger asChild>
          <div className="flex items-center justify-between p-6 rounded-lg text-white bg-[#e71875] hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-center">
              <FileText size={40} className="mr-4" />
              <span className=" text-2xl font-bold">View sample hotel room</span>
            </div>
            <ArrowRight size={32} />
          </div>
        </DialogTrigger>

        <DialogContent className="p-0 h-[80vh] w-[80vw] sm:w-[50vw]">
          <DialogTitle className="sr-only">Sample Hotel Room</DialogTitle>
          <div className="relative w-full h-full flex items-center justify-center bg-black">
            <img
              src="/global/dubai-hotel-sample.jpg"
              alt="Sample Dubai Hotel Room"
              className="object-contain max-h-full max-w-full"
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
